import React, { useEffect, useState } from "react";
import { Table, Container, Badge, Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import Loader from "../../components/loader/loader";
import NoDataFound from "../../components/NoDataFound/NoDataFound";
let baseurl = process.env.REACT_APP_BASE_URL

const AppliedJobList = () => {
    const [jobs, setJobs] = useState([]);
    const staticUser = { email: "hr@happimobiles.com", password: "Happi@hr555" };
    const [userCaptcha, setUserCaptcha] = useState("");
    const [captcha, setCaptcha] = useState("");
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [user, setUser] = useState(null);
    const [credentials, setCredentials] = useState({ email: "", password: "" });
    const [loader,setLoader]=useState(true);


    useEffect(() => {
        const storedUser = sessionStorage.getItem("user");
        if (storedUser) {
            setUser(JSON.parse(storedUser));
            setIsLoggedIn(true);
        }
    }, []);


    useEffect(() => {
        getAppliedJobsList()
    }, []);

    const handleChange = (e) => {
        setCredentials({ ...credentials, [e.target.name]: e.target.value });
    };

    const getAppliedJobsList = async () => {
        let response = await axios(`${baseurl}/api/happicareers`);
        let result = await response.data;
        if (result?.success) {
            setJobs(result.data);
            setLoader(false);
        }
    }

    useEffect(() => {
        generateCaptcha(); 
    }, []);

    const generateCaptcha = () => {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";
        for (let i = 0; i < 6; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        setCaptcha(result);
    };

    const handleLogin = (e) => {
        e.preventDefault();
        if (userCaptcha !== captcha) {
            toast.error("CAPTCHA is incorrect. Please try again.")
            generateCaptcha(); // regenerate captcha on wrong attempt
            setUserCaptcha("");
            return;
        }
        if (
            credentials.email === staticUser.email &&
            credentials.password === staticUser.password
        ) {
            setUser(staticUser);
            setIsLoggedIn(true);
            toast.success("Login Successfully")
            sessionStorage.setItem("user", JSON.stringify(staticUser));
        } else {
            toast.error("Invalid email or password");
        }
    };

    if (!isLoggedIn) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100" style={{ backgroundColor: "#f47933" }}>
                <div className="card p-4" style={{ width: "350px" }}>
                    <h3 className="text-center mb-4">Login</h3>
                    <form onSubmit={handleLogin} autoComplete="off">
                        <div className="mb-3">
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                className="form-control"
                                value={credentials?.email ? credentials.email : ""}
                                onChange={handleChange}
                                autoComplete="off"
                                required
                            />
                        </div>
                        <div className="mb-1">
                            <input
                                type="password"
                                name="password"
                                placeholder="Password"
                                className="form-control"
                                value={credentials?.password ? credentials.password : ""}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div style={{ margin: "20px 0" }}>
                            <label>Enter CAPTCHA:</label>
                            <div
                                style={{
                                    backgroundColor: "#f0f0f0",
                                    padding: "10px",
                                    fontWeight: "bold",
                                    letterSpacing: "3px",
                                    display: "inline-block",
                                    marginBottom: "5px",
                                }}
                            >
                                {captcha}
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <input
                                    type="text"
                                    value={userCaptcha}
                                    onChange={(e) => setUserCaptcha(e.target.value)}
                                    className="form-control"
                                    required
                                />
                                <button
                                    onClick={generateCaptcha}
                                    className="btn btn-secondary"
                                >
                                    Refresh
                                </button>
                            </div>

                        </div>

                        <button type="submit" className="btn btn-primary w-100 mb-3 mt-3">
                            Login
                        </button>
                    </form>


                </div>
            </div>
        );
    }


    return (
        <Container fluid className={jobs?.length>0?"vh-100":""} style={{ backgroundColor: "#f47933" }}>
            <h2 className="mb-4 text-white text-center text-uppercase">Applied Job List</h2>
           {loader?<Loader/>:jobs.length>0?<Table striped bordered hover responsive>
                <thead>
                    <tr>

                        <th>First Name</th>
                     <th>Last Name</th>
                        <th>Mobile No</th>
                        <th>Email ID</th>
                        <th>Location</th>
                        <th>Applied On</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {jobs.map((job, index) => (
                        <tr key={job.id}>
                            <td className="text-capitalize">{job.firstName}</td>
                           <td className="text-capitalize">{job.lastName}</td>
                            <td>{job.mobile}</td>
                            <td>{job.email}</td>
                            <td>{job.location}</td>
                            <td>{moment(job.createdAt).format("DD-MM-YYYY")}</td>

                            <td>
                                <a href={job.resume} download>
                                    <Button variant="outline-primary" size="sm" className="me-2">
                                        Download Resume
                                    </Button>
                                </a>

                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>:<div className="d-flex align-items-center justify-content-center text-white">
               <NoDataFound/>
                </div>}
        </Container>
    );
};

export default AppliedJobList;
